/* Other articles — staggered scroll-into-view entrance.
 *
 * The cards rest hidden (opacity 0 + slight drop, set in CSS under `.js` so
 * there's no flash before this deferred script runs) and fade + rise in,
 * staggered first → last via nth-child delays in other-articles.css. This
 * script just adds `is-in-view` to each grid once it scrolls into view, then
 * unobserves. Skips reduced-motion (CSS leaves the cards visible there).
 */
(function () {
  const reduceMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  const grids = Array.from(document.querySelectorAll('.other-articles__grid'));
  if (!grids.length) return;

  if (!('IntersectionObserver' in window)) {
    grids.forEach((grid) => grid.classList.add('is-in-view'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in-view');
        obs.unobserve(entry.target);
      });
    },
    { threshold: 0.2 }
  );

  grids.forEach((grid) => observer.observe(grid));
})();
